// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterWidgetWrapper_wrapper__HI0pL"};